import React from 'react';
import * as FiIcons from 'react-icons/fi';
import * as LuIcons from 'react-icons/lu';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  try {
    // If an icon object is passed directly (e.g. from react-icons/lu)
    if (icon) {
      IconComponent = icon;
    } 
    // Fallback for name-based lookup
    else if (name) {
      IconComponent = FiIcons[`Fi${name}`] || LuIcons[`Lu${name}`];
    }
  } catch (e) {
    IconComponent = null;
  }

  return IconComponent
    ? React.createElement(IconComponent, props)
    : <FiAlertTriangle {...props} />;
};

export default SafeIcon;